import React from "react";
import { Routes, Route } from "react-router-dom";
import GlobalProvider from "../../../GlobalProvider/GlobalProvider";
import ContactUs from "../ContactUs/ContactUs";
import Home from "../Home/Home";
import Withdraw from "../Withdraw/Withdraw";
import NotFound from "../NotFound/NotFound";

const Main = () => {
  return (
    <>
    <GlobalProvider>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/withdraw" element={<Withdraw />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      </GlobalProvider>
    </>
  );
};

export default Main;
